import './GatewayCard.scss';
import classNames from 'classnames';
import { When } from 'react-if';
import { Card, Flex } from 'antd';
import React from 'react';
export const GatewayCard = ({ children, className, id, pre, title }) => React.createElement(Card, { className: classNames('gateway-card', className), id: id },
    React.createElement(When, { condition: Boolean(pre) }, pre),
    React.createElement(Flex, { gap: 16, justify: 'space-between', vertical: true },
        React.createElement("div", { className: 'h1' }, title),
        children));
